import * as yup from 'yup';
import {
  CrewGuestType,
  RequestedServiceTicketType,
} from '../Data.conf';
import { API as marina } from '../../../marina/api';

export const TicketHelicopterTransferConf = {
  schema: {
    service_date: yup.date().nullable().required('Service date is required'),
    service_time: yup.string().nullable().required('Service time is required').test(
      'is-time',
      'Service Time format invalid',
      value => {
        if (!value) return true;
        return /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/.test(value);
      }
    ),
    id_marina: yup.object().nullable(),
    pickup_site: yup.string().nullable().required('Pickup site is required'),
    drop_off_site: yup
      .string()
      .nullable()
      .required('Drop off site is required'),
    requested_service_ticket: yup
      .object()
      .nullable()
      .required('Requested service is required'),
    return: yup.boolean().nullable(),
    return_date: yup.date().nullable(),
    return_time: yup.string().nullable().test(
      'is-time',
      'Return Time format invalid',
      value => {
        if (!value) return true;
        return /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/.test(value);
      }
    ),
    pax_number: yup.string().nullable().required('Pax is required'),
    crew_guest: yup.object().nullable().required('Crew / Guest is required'),
  },
  defaultValues: {
    service_date: null,
    id_marina: null,
    service_time: null,
    pickup_site: null,
    drop_off_site: null,
    requested_service_ticket: null,
    return: false,
    return_date: null,
    return_time: null,
    pax_number: null,
    crew_guest: null,
  },
  fields: [
    {
      id: 'reservation_divider',
      type: 'divider',
      label: 'Reservation',
      xs: 12,
    },
    {
      id: 'service_date',
      name: 'service_date',
      type: 'date',
      label: 'Service date',
      required: true,
      xs: 12,
      sm: 6,
    },
    {
      id: 'service_time',
      name: 'service_time',
      type: 'time',
      label: 'Service time',
      required: true,
      xs: 12,
      sm: 6,
    },

    {
      id: 'pickup_site',
      name: 'pickup_site',
      type: 'text',
      label: 'Pickup site',
      required: true,
      xs: 12,
      sm: 6,
    },
    {
      id: 'drop_off_site',
      name: 'drop_off_site',
      type: 'text',
      label: 'Drop off site',
      required: true,
      xs: 12,
      sm: 6,
    },
    {
      id: 'pax_number',
      name: 'pax_number',
      type: 'number',
      label: 'Pax',
      required: true,
      xs: 12,
      sm: 6,
    },
    {
      id: 'requested_service_ticket',
      name: 'requested_service_ticket',
      type: 'autocomplete',
      label: 'Requested service',
      required: true,
      options: RequestedServiceTicketType,
      xs: 12,
      sm: 6,
    },
    {
      id: 'return',
      name: 'return',
      type: 'switch',
      label: 'Return',
      required: false,
      xs: 12,
    },
    {
      id: 'return_date',
      name: 'return_date',
      type: 'date',
      label: 'Return date',
      required: false,
      xs: 12,
      sm: 6,
    },
    {
      id: 'return_time',
      name: 'return_time',
      type: 'time',
      label: 'Return time',
      required: false,
      xs: 12,
      sm: 6,
    },

    {
      id: 'crew_guest',
      name: 'crew_guest',
      type: 'autocomplete',
      label: 'Crew / Guest',
      options: CrewGuestType,
      required: true,
      xs: 12,
      sm: 6,
    },
    {
      id: 'id_marina',
      name: 'id_marina',
      type: 'async_autocomplete',
      label: 'Location',
      api: marina.select,
      required: false,
      xs: 12,
      sm: 6,
    },
  ],
};
